import { z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const SMSNotificationStatusOptions = [
  'ACCEPTED',
  'SCHEDULED',
  'QUEUED',
  'SENDING',
  'SENT',
  'DELIVERED',
  'UNDELIVERED',
  'FAILED',
  'DELIVERY_UNKNOWN'
] as const
export const SMSNotificationStatuses = enumOptionsToObject(SMSNotificationStatusOptions)

export const SMSNotificationStatus = z.enum(SMSNotificationStatusOptions).setEnumLabels({
  [SMSNotificationStatuses.ACCEPTED]:
    'Twilio has received your API request to immediatedly send an outbound message with a Messaging Service.',
  [SMSNotificationStatuses.SCHEDULED]: 'The Message resource is scheduled to be sent with a Messaging Service.',
  [SMSNotificationStatuses.QUEUED]: 'The API request to send an outbound message was successful and the message is queued',
  [SMSNotificationStatuses.SENDING]:
    'Twilio is in the process of dispatching the outbound message to the nearest upstream carrier in the network.',
  [SMSNotificationStatuses.SENT]: 'The nearest upstream carrier accepted the outbound message.',
  [SMSNotificationStatuses.DELIVERED]:
    'Twilio has received confirmation of outbound message delivery from the upstream carrier, and, where available, the destination handset.',
  [SMSNotificationStatuses.UNDELIVERED]:
    'Twilio received a delivery receipt indicating that the outbound message was not delivered.',
  [SMSNotificationStatuses.FAILED]: 'The outbound message failed to send.',
  [SMSNotificationStatuses.DELIVERY_UNKNOWN]: 'Unknown status of delivery'
})

export type SMSNotificationStatus = z.infer<typeof SMSNotificationStatus>
